<mat-card>
  <mat-card-content>

    <div class="flex-center-center flex-direction-column w100">
      @if (isSetSlideValue) {
      <div class="flex-around-center flex-direction-row w100 ">
        <button mat-icon-button (click)="slideBefore()" color="primary">
          <mat-icon>navigate_before</mat-icon>
        </button>
        {{traductionSlidesValue|translate}}
        <button mat-icon-button (click)="slideNext()" color="primary">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
      }
      @if (isSetChips) {
      <div class="flex-center-center flex-direction-row w100">
        <div class="flex-start-center flex-direction-row" style="max-width: 100%">
          @for (chip of data.chips; track chip) {
          <div [ngClass]="[chipsSizeClass,cssChips(chip)]" (click)="clickChips(chip)">
            <mat-card mat-ripple class="background-default  cursor">
              {{chip.traductionKey|translate}}
            </mat-card>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </mat-card-content>
  <mat-card-actions>
    @if (isSetSlideValue) {
    <div class="flex-around-center flex-direction-row w100 " style="margin-top: 10px">
      <button mat-stroked-button (click)="emitValue(false)" color="accent">
        <mat-icon>clear</mat-icon>
      </button>
      <button mat-stroked-button (click)="emitValue(true)" color="primary" [disabled]="disableCheckButton">
        <mat-icon>check</mat-icon>
      </button>
    </div>
    }
  </mat-card-actions>
</mat-card>